import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core'
import { Store } from '@ngxs/store'
import {
  BookmarksState,
  BookmarkTypeToLabel,
  DeleteBookmark,
  IBookmarkItem
} from '@lla-platform/users/users-data-access'
import { finalize, Observable } from 'rxjs'
import { IMenuRouteInfo } from '../../interfaces/menu.interface'
import { FiltersState } from '@lla-platform/core/core-data-access'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { SidemenuBottomSheetComponent } from '../sidemenu-bottom-sheet/sidemenu-bottom-sheet.component'

@UntilDestroy()
@Component({
  selector: 'lla-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MainHeaderComponent implements OnInit, OnDestroy {
  @Input() mainMenuRoutes: IMenuRouteInfo[]
  @Output() showLargeMenuChanged = new EventEmitter<boolean>()

  bookmarks$: Observable<IBookmarkItem[]> = inject(Store).select(BookmarksState.bookmarks)

  deletingBookmarkId?: string
  showLargeMenu = false
  bookmarks: IMenuRouteInfo[] = []
  isBottomSheetMenuOpen = false

  constructor(
    private store: Store,
    public bottomSheetService: MatBottomSheet
  ) {}

  ngOnInit(): void {
    this.showLargeMenu = !!this.store.selectSnapshot(FiltersState.showLargeMenu)
    this.showLargeMenuChanged.emit(this.showLargeMenu)

    this.addBookmarksMenuItems()

    this.bookmarks$.pipe(untilDestroyed(this)).subscribe((res) => {
      if (res) {
        this.addBookmarksMenuItems()
      }
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth >= 976) {
      this.bottomSheetService.dismiss()
    }
  }

  ngOnDestroy(): void {
    this.bottomSheetService.dismiss()
  }

  addBookmarksMenuItems() {
    const bookmarkItems = this.store.selectSnapshot(BookmarksState.bookmarks)
    const listPagesPath = this.store.selectSnapshot(FiltersState.listPagesPath)
    this.bookmarks = bookmarkItems.map((el) => ({
      icon: 'redo',
      label: `${BookmarkTypeToLabel[el.type]} - ${el.name}`,
      type: 'bookmark',
      path: listPagesPath[el.type],
      queryParams: {
        filters: el.token
      },
      extraInfo: el.id
    }))
  }

  deleteBookmark(event: Event, id: string) {
    event.preventDefault()
    event.stopPropagation()

    if (this.deletingBookmarkId) {
      return
    }

    this.deletingBookmarkId = id
    this.store
      .dispatch(new DeleteBookmark(id))
      .pipe(
        untilDestroyed(this),
        finalize(() => (this.deletingBookmarkId = undefined))
      )
      .subscribe()
  }

  openSideMenuBottomSheet() {
    this.isBottomSheetMenuOpen = true
    this.bottomSheetService
      .open(SidemenuBottomSheetComponent, {
        data: {
          items: this.mainMenuRoutes
        },
        autoFocus: false,
        backdropClass: 'bg-transparent'
      })
      .afterDismissed()
      .subscribe(() => {
        this.isBottomSheetMenuOpen = false
      })
  }
}
